import Repository from "./repository"

const resource = 'dashboard';

export default {
    async getWeekRooms({ startDate, days }) {
        let endpoint = `${resource}/rooms/${startDate}/${days}`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async getActiveUsers({ take }) {
        let endpoint = `${resource}/users/${take}`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async getClosedRooms({ take }) {
        let endpoint = `${resource}/rooms/closed/${take}`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async getOpenRooms({ take }) {
        let endpoint = `${resource}/rooms/open/${take}`;
        let response = await Repository.get(endpoint);
        return response;
    },
}